// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button__Button__ajevi","Success":"Button__Success__1DMln","Danger":"Button__Danger__18hYt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Button/Button.css
// module id = 116
// module chunks = 0